module.exports = __webpack_public_path__ + "img/slide9_vn.df08f287.jpg";